// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"137":"4971eadf51f5534c","180":"f42bc526cbbdc9d7","536":"918dd7c9d411e6e7"}[chunkId] + ".js";
};